import { rootApi } from "./config";
import session from "../utils/session";
import axios from "axios";

const headers = async () => ({
  Authorization: `Bearer ${await session.getToken()}`,
  "Content-Type": "application/json",
});

export const getRoadbookPages = async () => {
  const response = await axios.get(`${rootApi}/roadbook_pages`, { headers: await headers() });
  return response.data;
};

export const getRoadbookPage = async (id) => {
  const response = await axios.get(`${rootApi}/roadbook_pages/${id}`, { headers: await headers() });
  return response.data;
};

export const createRoadbookPage = async (data) => {
  const response = await axios.post(`${rootApi}/roadbook_pages`, data, { headers: await headers() });
  return response.data;
};

export const updateRoadbookPage = async (id, data) => {
  const response = await axios.patch(`${rootApi}/roadbook_pages/${id}`, data, { headers: await headers() });
  return response.data;
};

export const deleteRoadbookPage = async (id) => {
  const response = await axios.delete(`${rootApi}/roadbook_pages/${id}`, { headers: await headers() });
  return response.data;
};

export const getMessageTemplates = async () => {
  const response = await axios.get(`${rootApi}/client_message_templates`, { headers: await headers() });
  return response.data;
};

export const updateMessageTemplate = async (id, data) => {
  const response = await axios.patch(`${rootApi}/client_message_templates/${id}`, data, { headers: await headers() });
  return response.data;
};
